/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { useDtfStore } from "./store";
import "./ArtworkNotification.scss";

export default function ArtworkNotification({ type = "warning", children, ...restProps }: any) {
  const store = useDtfStore();

  function showStepsUI() {
    // @ts-expect-error TS(4111): Property 'showStepsUI' comes from an index signatu... Remove this comment to see the full error message
    return store.showStepsUI;
  }

  return (
    <div
      {...restProps}
      className={cn(
        "artwork-notification scope-e6849d73",
        restProps?.className,
        `artwork-notification--${type}`,
        {
          "artwork-notification--steps-ui": showStepsUI()
        }
      )}
    >
      <div className="artwork-notification__container scope-e6849d73">
        <div className="artwork-notification__icon scope-e6849d73">
          <UseSvg
            className={cn(
              "artwork-notification__svg scope-e6849d73",
              `artwork-notification__svg--${type}`
            )}
            icon="alert-circle"
            data-testid="artwork-notification-svg"
          />
        </div>
        <div className="artwork-notification__message scope-e6849d73">{children}</div>
      </div>
    </div>
  );
}
